import { useDispatch, useSelector } from "react-redux";
import { fieldsToCheckBonding } from "../../../data/permitFormsData";
import FinancialBPModal from "../FinancialBPModal";
import React from "react";
import { setBuildingState } from "../../../store/actions/permitFormActions/buildingStateActions";

const AddingNewBondingModal = () => {
  const { addingNewBonding } = useSelector((state) => state.buildingState);

  const dispatch = useDispatch();

  return (
    <FinancialBPModal
      type="bonding"
      open={addingNewBonding}
      title={"Add New Bonding Company"}
      handleStateNo={() => {
        dispatch(setBuildingState({ addingNewBonding: false }));
      }}
      fieldsToCheck={fieldsToCheckBonding}
    />
  );
};

export default React.memo(AddingNewBondingModal);
